import {
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { color } from "framer-motion";
import React from "react";
import { FaFacebookF } from "react-icons/fa6";
import { FaTwitter } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";
import { FaLinkedinIn } from "react-icons/fa";
import { BsWhatsapp } from "react-icons/bs";
import { FaLessThan } from "react-icons/fa";
import { FaGreaterThan } from "react-icons/fa";
import { LuLayoutGrid } from "react-icons/lu";
import BlogSliderSection from "./BlogSliderSection";
import BlogCommentSection from "./BlogCommentSection";

const CommentSection = () => {
  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        marginBottom: "40px",
      }}
    >
      <Stack
        sx={{
          // border: "1px solid #ddd",
          width: { xl: "68%", lg: "80%", md: "90%", sm: "96%", xs: "100%" },
        }}
      >
        {/* <Divider sx={{ my: 2 }} /> */}
        <Stack
          sx={{
            // border: "1px solid red",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "16px",
          }}
        >
          <Stack sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
            <Stack
              sx={{
                height: {
                  xl: "40px",
                  lg: "40px",
                  md: "40px",
                  sm: "40px",
                  xs: "40px",
                },
                width: {
                  xl: "40px",
                  lg: "40px",
                  md: "40px",
                  sm: "40px",
                  xs: "40px",
                },
                borderRadius: "50%",
                backgroundColor: "#365493",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FaFacebookF size={20} style={{ color: "#FFFFFF" }} />
            </Stack>
            <Stack
              sx={{
                height: {
                  xl: "40px",
                  lg: "40px",
                  md: "40px",
                  sm: "40px",
                  xs: "40px",
                },
                width: {
                  xl: "40px",
                  lg: "40px",
                  md: "40px",
                  sm: "40px",
                  xs: "40px",
                },
                borderRadius: "50%",
                backgroundColor: "#33ccff",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FaTwitter size={20} style={{ color: "#FFFFFF" }} />
            </Stack>
            <Stack
              sx={{
                height: {
                  xl: "40px",
                  lg: "40px",
                  md: "40px",
                  sm: "40px",
                  xs: "40px",
                },
                width: {
                  xl: "40px",
                  lg: "40px",
                  md: "40px",
                  sm: "40px",
                  xs: "40px",
                },
                borderRadius: "50%",
                backgroundColor: "#f89a1e",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <IoMdMail size={20} style={{ color: "#FFFFFF" }} />
            </Stack>
            <Stack
              sx={{
                height: {
                  xl: "40px",
                  lg: "40px",
                  md: "40px",
                  sm: "40px",
                  xs: "40px",
                },
                width: {
                  xl: "40px",
                  lg: "40px",
                  md: "40px",
                  sm: "40px",
                  xs: "40px",
                },
                borderRadius: "50%",
                backgroundColor: "#0274b3",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FaLinkedinIn size={20} style={{ color: "#FFFFFF" }} />
            </Stack>
            <Stack
              sx={{
                height: {
                  xl: "40px",
                  lg: "40px",
                  md: "40px",
                  sm: "40px",
                  xs: "40px",
                },
                width: {
                  xl: "40px",
                  lg: "40px",
                  md: "40px",
                  sm: "40px",
                  xs: "40px",
                },
                borderRadius: "50%",
                backgroundColor: "#1ebea5",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <BsWhatsapp size={20} style={{ color: "#FFFFFF" }} />
            </Stack>
          </Stack>
        </Stack>

        {/* newer and older button */}
        {/* <Stack
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // border: "1px solid red",
          }}
        >
          <Stack
            sx={{
              // border: "1px solid #ddd",
              marginTop: "40px",
              width: {
                xl: "100%",
                lg: "80%",
                md: "90%",
                sm: "96%",
                xs: "100%",
              },
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              border: "1px solid red",
            }}
          >
           
            <Stack
              sx={{
                width: { xl: "40%", lg: "40%", md: "40%", sm: "40%" },
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                border: "2px solid blue",
              }}
            >
              <Stack
                sx={{
                  width: { xl: "10%" },
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {" "}
                <Stack
                  sx={{
                    height: { xl: "40px" },
                    width: { xl: "40px" },
                    borderRadius: "50%",
                    backgroundColor: "#365493",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FaLessThan size={20} style={{ color: "#FFFFFF" }} />
                </Stack>
              </Stack>{" "}
              <Stack
                sx={{
                  width: { xl: "90%" },
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  // border: "2px solid green",
                }}
              >
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Stack sx={{ width: "100%" }}>Newer</Stack>
                  <Stack sx={{ width: "100%" }}>Discription</Stack>
                  <Stack sx={{ width: "100%" }}>
                    <Button variant="contained">Reading Time Button</Button>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          
            <Stack
              sx={{
                width: { xl: "20%" },
                // border: "1px solid red",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Stack>
                <LuLayoutGrid size={20} style={{ color: "grey" }} />
              </Stack>
            </Stack>
           
            <Stack
              sx={{
                width: { xl: "40%" },
                display: "flex",
                flexDirection: "row",
                // justifyContent: "space-between",
                // border: "1px solid blue",
              }}
            >
              <Stack
                sx={{
                  width: { xl: "90%" },
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  // border: "2px solid green",
                }}
              >
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "column",

                    width: "100%",
                  }}
                >
                  <Stack
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-end",
                    }}
                  >
                    Older
                  </Stack>
                  <Stack
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-end",
                    }}
                  >
                    Discription
                  </Stack>
                  <Stack
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button variant="contained">Reading Time Button</Button>
                  </Stack>
                </Stack>
              </Stack>
              <Stack
                sx={{
                  width: { xl: "10%" },
                  // border: "2px solid green",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Stack
                  sx={{
                    height: { xl: "40px" },
                    width: { xl: "40px" },
                    borderRadius: "50%",
                    backgroundColor: "#365493",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FaGreaterThan size={20} style={{ color: "#FFFFFF" }} />
                </Stack>
              </Stack>{" "}
            </Stack>
          </Stack>
        </Stack> */}
        <BlogSliderSection />

        <Divider sx={{ my: 2 }} />

        {/* Leave a reply section */}

        {/* <Stack sx={{ border: "2px solid red" }}>
          <Stack>
            <Stack
              sx={{
                fontSize: {
                  xs: "22px",
                  sm: "28px",
                  md: "28px",
                  lg: "28px",
                  xl: "28px",
                },
                lineHeight: {
                  xs: "32px",
                  sm: "32px",
                  md: "40px",
                  lg: "40px",
                  xl: "40px",
                },
                fontWeight: { xs: 400, sm: 400, md: 400, lg: 400, xl: 400 },
                color: "black",
                fontFamily:
                  "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                marginBottom: {
                  xl: "16px",
                  lg: "16px",
                  md: "16px",
                  sm: "16px",
                  xs: "16px",
                },
              }}
            >
              Leave a Reply{" "}
            </Stack>
            <Stack
              sx={{
                marginBottom: {
                  xl: "16px",
                  lg: "16px",
                  md: "16px",
                  sm: "16px",
                  xs: "16px",
                },
              }}
            >
              <span>
                Your email address will not be published. Required fields are
                marked <span style={{ color: "red" }}>*</span>
              </span>
            </Stack>

            <Stack
              sx={{
                marginBottom: {
                  xl: "16px",
                  lg: "16px",
                  md: "16px",
                  sm: "16px",
                  xs: "16px",
                },
              }}
            >
              <TextField
                required
                label="Comment"
                multiline
                rows={4}
                variant="outlined"
                fullWidth
              />
            </Stack>

            <Stack
              direction={{
                xs: "column",
                sm: "row",
              }}
              spacing={2}
              sx={{
                marginBottom: {
                  xl: "16px",
                  lg: "16px",
                  md: "16px",
                  sm: "16px",
                  xs: "16px",
                },
              }}
            >
              <TextField required label="Name" variant="outlined" fullWidth />
              <TextField
                required
                label="Email"
                type="email"
                variant="outlined"
                fullWidth
              />
            </Stack>

            <Stack
              sx={{
                marginBottom: {
                  xl: "16px",
                  lg: "16px",
                  md: "16px",
                  sm: "16px",
                  xs: "16px",
                },
              }}
            >
              <TextField label="Website" variant="outlined" fullWidth />
            </Stack>

           
            <FormControlLabel
              control={<Checkbox />}
              label="Save my name, emailand website in this browser for the next time I comment."
              sx={{
                marginBottom: {
                  xl: "16px",
                  lg: "16px",
                  md: "16px",
                  sm: "16px",
                  xs: "16px",
                },
              }}
            />

           
            <Button
              variant="contained"
              color="success"
              sx={{
                fontWeight: "bold",
                textTransform: "uppercase",
                maxWidth: 200,
                marginBottom: {
                  xl: "16px",
                  lg: "16px",
                  md: "16px",
                  sm: "16px",
                  xs: "16px",
                },
              }}
            >
              Post Comment
            </Button>
          </Stack>
        </Stack> */}
        <BlogCommentSection />
      </Stack>
    </Stack>
  );
};

export default CommentSection;
